import React from 'react'
import { Tag } from 'antd'

import { getPermissionTagColor } from './utils'

export const PermissionTag: React.FC<{
  name: string
  closable?: boolean
  onClose?: () => void
}> = ({ name, closable = false, onClose }) => (
  <Tag
    color={getPermissionTagColor(name)}
    closable={closable}
    onClose={onClose}
    style={{ marginInlineEnd: 4 }}
  >
    {name}
  </Tag>
)
